import { motion } from "framer-motion";
import { GeneratedArticle } from "../GeneratedArticle";
import { useOnboarding } from "@/context/OnboardingContext";
import useUserInteractionHandling from "@/hooks/useUserInteractionHandling";

export default function GeneratingFirstPieceOfContentStep() {
  const { state, setState } = useOnboarding();
  const { handleContinueToScheduling } = useUserInteractionHandling();

  return (
    <motion.div
      key="step-3"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{
        duration: 0.5,
        ease: "easeInOut",
        opacity: { duration: 0.3 },
      }}
      className="w-full py-4"
    >
      <div className="w-full mx-auto max-w-4xl">
        <motion.div className="text-center space-y-3 mb-8">
          <motion.h2
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.4 }}
            className="text-3xl font-bold"
          >
            Look what's sprouting! 🌱
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.4 }}
            className="text-muted-foreground text-lg max-w-xl mx-auto"
          >
            Here's your first seedling - a quick draft in your voice. Like any young
            plant, it might need some pruning and care, but the roots are there!
          </motion.p>
        </motion.div>

        <GeneratedArticle
          contentGenerated={state.contentGenerated}
          progress={state.progress}
          currentStepText={state.currentStepText}
          generatedContentTitle={state.generatedContentTitle}
          generatedContentPreview={state.generatedContentPreview}
          showRawContent={state.showRawContent}
          onToggleRawContent={() =>
            setState((prev) => ({ ...prev, showRawContent: !prev.showRawContent }))
          }
          onContinue={handleContinueToScheduling}
        />
      </div>
    </motion.div>
  );
}
